import { r } from './useApi';
import { keeper } from './utils';
import { normalizeBySchema } from './useDataModels';

export const listSnippets = async (filter = {}) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/snippet`,
        sessionToken: keeper('sessionToken'),
        method: 'get',
        data: filter,
    });
    return res;
};

export const getSnippet = async (snippetId) => {
    let res = {},
        searchEndpoint = '/v2/snippet';

    if (snippetId !== '0') {
        res =
            (await r({
                endpoint: `${keeper('apiUrl')}/v2/snippet/${snippetId}`,
                sessionToken: keeper('sessionToken'),
                method: 'get',
            })) || {};
    }

    if (Object.keys(res).length === 0) {
        res = await normalizeBySchema(searchEndpoint, 'post', res);
    }

    return res;
};

export const saveSnippet = async (snippetId, data, saving = {}) => {
    let method = 'put',
        endpoint = `${keeper('apiUrl')}/v2/snippet/${snippetId}`,
        searchEndpoint = '/v2/snippet/{snippetId}',
        defaultTypeName = 'SnippetDto';

    if (snippetId === '0') {
        method = 'post';
        searchEndpoint = '/v2/snippet';
        endpoint = `${keeper('apiUrl')}/v2/snippet`;
        // THIS WILL LIKELY CHANGE defaultTypeName = 'SnippetDto';
    }

    const dataModel = await normalizeBySchema(searchEndpoint, method, data);
    dataModel.typeName =
        !dataModel.typeName || dataModel.typeName.length === 0
            ? defaultTypeName
            : dataModel.typeName;

    const res = await r({
        endpoint: endpoint,
        sessionToken: keeper('sessionToken'),
        method: method,
        data: dataModel,
    });

    saving.active = false;
    return res;
};

export const useSnippets = () => {
    return {
        listSnippets: listSnippets,
        getSnippet: getSnippet,
        saveSnippet: saveSnippet,
    };
};

export default useSnippets;
